const $ = window.jQuery;

const COOKIE_NAME = 'caetanogo_data';

const delete_cookie = (name) => {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const cookie_exists = (name) => {
  return document.cookie.indexOf(name + '=') !== -1;
}

const cg_logout = () => {
  delete_cookie(COOKIE_NAME)
  window.location.reload();
};

const cg_toggleMenu = () => {
  const menuElement = document.querySelectorAll('#login-caetano .login-caetano-menu')
  menuElement.forEach(elem => {
    elem.classList.toggle("show")
  })
};

export const caetano_go__init = () => {
  window.caetano_go__logout = cg_logout;
  window.caetano_go__toggleMenu = cg_toggleMenu;

  // display login or logout
  if (cookie_exists(COOKIE_NAME)) {
    $('.caetano-go--logged-in').removeClass('caetano-go--hidden');
  }
  else {
    $('.caetano-go--not-logged-in').removeClass('caetano-go--hidden');
  }

};
